import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface QuoteAIRequest {
  prompt_id?: string;
  prompt_template?: string;
  quote_id: string;
  context?: any;
  module_type?: string;
}

export interface QuoteAIResponse {
  success: boolean;
  content: string;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class AIQuoteService {
  private readonly strBaseUrl = environment.url + '/ai/quotes';

  constructor(private readonly objHttp: HttpClient) {}

    generateSummary(objRequest: QuoteAIRequest): Observable<QuoteAIResponse> {
    // Convert object to FormData for proper form encoding
    const formData = new FormData();
    Object.keys(objRequest).forEach(key => {
      if (objRequest[key] !== null && objRequest[key] !== undefined) {
        if (key === 'context' && typeof objRequest[key] === 'object') {
          // Convert context object to JSON string for form data
          formData.append(key, JSON.stringify(objRequest[key]));
        } else {
          formData.append(key, objRequest[key]);
        }
      }
    });

    // Add module_type for smart filtering
    formData.append('module_type', 'quotes');

    return this.objHttp.post<QuoteAIResponse>(`${this.strBaseUrl}/summary`, formData);
  }

    generateCoverLetter(objRequest: QuoteAIRequest): Observable<QuoteAIResponse> {
    // Convert object to FormData for proper form encoding
    const formData = new FormData();
    Object.keys(objRequest).forEach(key => {
      if (objRequest[key] !== null && objRequest[key] !== undefined) {
        if (key === 'context' && typeof objRequest[key] === 'object') {
          // Convert context object to JSON string for form data
          formData.append(key, JSON.stringify(objRequest[key]));
        } else {
          formData.append(key, objRequest[key]);
        }
      }
    });

    // Add module_type for smart filtering
    formData.append('module_type', 'cover_letter');

    return this.objHttp.post<QuoteAIResponse>(`${this.strBaseUrl}/cover-letter`, formData);
  }
}


